import React from 'react';
import { Box, Typography } from '@mui/material';
import { useTheme } from '@manulife/mux';
import { setStylesInfoPannel } from '../../styles/infoPannel.styles';

const SprntInfo = ({ type }) => {
  const theme = useTheme();
  const styles = setStylesInfoPannel(theme);

  return (
    <Box sx={styles.ctn}>
      <Typography sx={styles.faq}>If you need assistance</Typography>
      <Typography sx={styles.note}>
        <strong>Please contact your John Hancock Relationship Manager</strong>
      </Typography>
    </Box>
  );
};

export default SprntInfo;
